import { AltroSoggetto } from './altro-soggetto';
import { Compagnia } from './compagnia';
import { Model } from './model';
import { User } from './user';

export class PreferenzaAmministratore extends Model {
  static apiUrl: string = 'preferenze_amministratori';

  altro_soggetto?: AltroSoggetto;
  altro_soggetto_id?: number;

  compagnia?: Compagnia;
  compagnia_id?: number;

  incaricato?: User;
  incaricato_id?: number;

  deserialize(input: any): PreferenzaAmministratore {
    let retV: PreferenzaAmministratore = new PreferenzaAmministratore();

    retV = super.deserialize(input) as PreferenzaAmministratore;

    if (input?.altro_soggetto) {
      retV.altro_soggetto = new AltroSoggetto().deserialize(input.altro_soggetto);
    }

    if (input?.compagnia) {
      retV.compagnia = new Compagnia().deserialize(input.compagnia);
    }

    if (input?.incaricato) {
      retV.incaricato = new User().deserialize(input.incaricato);
    }

    return retV;
  }

  public getHumanIdentifier() {
    const amministratore = this.altro_soggetto?.humanIdentifier || '';
    const compagnia = this.compagnia?.humanIdentifier || '';
    const incaricato = this.incaricato?.humanIdentifier || '';
    return [amministratore, compagnia, incaricato].filter(Boolean).join(' - ') || `${this.id}`;
  }
}
